module.exports = "/_next/static/images/calendar-big-ab7a2e10e5dbc6474151ec1d4be7f6ca.svg";